<ng-container *ngIf="studyResearchers$ | async as studyResearchers">
  <ng-container *ngrxLet="singleStudyResearcherVisible$ as singleStudyResearcherVisible">
    <div
      *ngIf="!singleStudyResearcherVisible"
      class="dashboard-study-researchers"
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
    >
      <div class="dashboard-study-researchers__header" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="dashboard-study-researchers__header-title">Researchers</div>
        <button
          mat-fab
          color="primary"
          aria-label="Add Researcher"
          (click)="openCreateResearcher()"
          *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.RESEARCHERS, PRIVILEGE_ACTIONS.ALL)"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <div
        class="dashboard-study-researchers__list"
        fxLayout="column"
        fxLayoutAlign="space-between stretch"
        fxLayoutGap="10px"
        *ngIf="selectedStudy$ | async as selectedStudy"
      >
        <mat-card
          class="dashboard-study-researchers__list-item"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          *ngFor="let researcher of studyResearchers"
          dashboardStudyTypeColor
          [studyType]="selectedStudy?.type"
          (click)="openResearcherDetails(researcher)"
        >
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="25px">
            <mat-icon
              class="dashboard-study-researchers__list-item-icon"
              [color]="selectedStudy?.researcherId === researcher?.id ? 'primary' : 'accent'"
            >
              perm_identity
            </mat-icon>
            <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="6px">
              <label class="dashboard-study-researchers__list-item-title">
                {{ researcher?.firstname + ' ' + researcher?.lastname }}
                <span
                  class="dashboard-study-researchers__list-item-title-badge"
                  *ngIf="selectedStudy?.researcherId === researcher?.id"
                  >owner</span
                >
                <span
                  class="dashboard-study-researchers__list-item-title-blocked-badge"
                  *ngIf="researcher?.pivot.blocked"
                >blocked</span>
              </label>
              <label class="dashboard-study-researchers__list-item-subtitle">{{ researcher?.email }}</label>
            </div>
          </div>
          <mat-icon
            class="dashboard-study-researchers__list-item-delete"
            #tooltip="matTooltip"
            matTooltip="Remove this researcher"
            matTooltipPosition="above"
            (click)="$event.stopPropagation(); deleteStudyResearcher(selectedStudy?.id, researcher?.id)"
            *ngIf="
              selectedStudy?.researcherId !== researcher?.id &&
              privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.RESEARCHERS, PRIVILEGE_ACTIONS.ALL)
            "
          >
            delete
          </mat-icon>
        </mat-card>
      </div>
    </div>
    <dashboard-study-researcher
      *ngIf="singleStudyResearcherVisible"
      [isAddResearcher]="isAddResearcher"
      [selectedStudy]="selectedStudy$ | async"
    >
    </dashboard-study-researcher>
  </ng-container>
</ng-container>
